<template>
  <div class="h-dialogContainer h-track-tabPage">
    <div class="row"></div>

    <div class="row h-row-inputBox">
      <div class="col-sm-10 h-col-inputBox">
        <div class="h-inputLit">{{$t('Observe.startTime')}}:</div>
        <ejs-datetimepicker
          format="yyyy-MM-dd HH:mm:ss"
          v-model="executeTime"
          :locale="locale"
          step="1"
          timeFormat="HH:mm:ss"
          :allowEdit="false"
          :enabled="true"
        ></ejs-datetimepicker>
      </div>
     <!-- <div class="col-sm-6 h-col-inputBox">
        <div class="h-inputLit">{{$t('Observe.endTime')}}:</div>
        <ejs-datetimepicker
          format="yyyy-MM-dd HH:mm:ss"
          v-model="endTime"
          :locale="locale"
          step="1"
          timeFormat="HH:mm:ss"
          :allowEdit="false"
          :enabled="true"
        ></ejs-datetimepicker>
      </div>-->
    </div>


  </div>
</template>
<script>
  export default {
    name: "AddMMLTimeTask",
    components: {},
    data() {
      return {
        locale: localStorage.getItem("locale"),
        executeTime: new Date()
        /*endTime: new Date(new Date().getTime() + 24 * 60 * 60 * 1000).Format(
          "yyyy-MM-dd HH:mm:ss"
        )*/
      };
    },
    methods: {
      getFormData() {
        return {
          executeTime: this.executeTime.getTime()
         /* endTime: this.endTime.getTime()*/
        };
      }
    },

  };
</script>
